// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CAP_NHAT_KHIEU_NAI, CREATE_KHIEU_NAI, DONG_KHIEU_NAI, GET_CHI_TIET_KHIEU_NAI, GET_LIST_KHIEU_NAI, GET_LIST_KHIEU_NAI_DONE, GET_LIST_KHIEU_NAI_THEO_USER, GET_LIST_KHIEU_NAI_THEO_USER_DONE, PHAN_HOI_KHIEU_NAI } from "./constant";

export const ActionGetDanhSachKhieuNai = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_LIST_KHIEU_NAI,
    payload,
    callback
  };
};

export const ActionGetDanhSachKhieuNaiDone = (data: any) => ({
  type: GET_LIST_KHIEU_NAI_DONE,
  payload: data
})

export const ActionGetChiTietKhieuNai = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_CHI_TIET_KHIEU_NAI,
    payload,
    callback
  };
};

export const ActionCraeteKhieuNai = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: CREATE_KHIEU_NAI,
    payload: payload,
    callback
  };
};

export const ActionDongKhieuNai = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: DONG_KHIEU_NAI,
    payload: payload,
    callback
  };
};

export const ActionPhanHoiKhieuNai = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: PHAN_HOI_KHIEU_NAI,
    payload: payload,
    callback
  };
};

export const ActionCapNhatKhieuNai = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: CAP_NHAT_KHIEU_NAI,
    payload: payload,
    callback
  };
};

export const ActionGetListKNByUser = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: GET_LIST_KHIEU_NAI_THEO_USER,
    payload: payload,
    callback
  };
};

export const ActionGetListKNByUserDone = (data: any) => ({
  type: GET_LIST_KHIEU_NAI_THEO_USER_DONE,
  payload: data
})

